<template>
  <qx-card-form title="司机工资" v-show="!userInfo && carUserType === '1'" :defaultContentShow="false">
    <span slot="titleLeft" class="warning" v-if="salaryPatternNameVer" style="margin-left: 10px">工资模式修改为{{salaryPatternNameVer}}，次月生效！</span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="salaryUnit" class="inputUnit">元/月</span>
      <span slot="subsidyUnit" class="inputUnit">元/天</span>
      <span slot="incomeRatioUnit" class="inputUnit">%</span>
      <section slot="salaryOther" slot-scope="prop">
        <SetSalary ref="setSalary" :salaryPattern="prop.form.salaryPattern" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import SetSalary from '../setSalary';
import {dealNumber, floatMutiply} from '@qx/utils';
export default {
  components: {
    SetSalary,
  },
  data () {
    return {
      salaryPatternNameVer: '',
      userInfo: null,
      carUserType: null,
      otherFormData: {
        meterList: [],
        tripList: [],
      },
      baseForm: {
        salaryPatternOptions: [],
        inline: true,
        form: [
          {
            label: '入职日期',
            value: 'entryDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '薪资模式',
            value: 'salaryPattern',
            type: 'select',
            onChange: () => {
              this.salaryPatternChange();
            },
          },
          {
            label: '基本工资',
            value: 'salary',
            type: 'input',
            hide: true,
          },
          {
            label: '补贴金额',
            value: 'subsidy',
            type: 'input',
            hide: true,
          },
          {
            label: '提成比例',
            value: 'incomeRatio',
            type: 'input',
            hide: true,
          },
          // {
          //   label: '底薪',
          //   value: 'basicSalary',
          //   type: 'input',
          //   unit: '元/月',
          //   hide: true,
          //   onInput: (basicSalary) => {
          //     this.$refs.baseForm.setVal('basicSalary', dealNumber(basicSalary, false));
          //   },
          // },
          // {
          //   label: '保底工资',
          //   value: 'minimumWage',
          //   type: 'input',
          //   unit: '元/月',
          //   hide: true,
          //   onInput: (minimumWage) => {
          //     this.$refs.baseForm.setVal('minimumWage', dealNumber(minimumWage, false));
          //   },
          // },
          {
            value: 'salaryOther',
            allCustom: true,
          },
        ],
        rules: {
          // salaryPattern: [ // 薪资模式
          //   { required: true, message: '请选择薪资模式', trigger: 'blur' },
          // ],
          // salary: [ // 基本工资
          //   { required: true, message: '请输入基本工资', trigger: 'blur' },
          // ],
          // subsidy: [ // 补贴金额
          //   { required: true, message: '请输入补贴金额', trigger: 'blur' },
          // ],
          // incomeRatio: [ // 提成比例
          //   { required: true, message: '请输入提成比例', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    receiveData (tar, val) {
      this.userInfo = val.userInfo;
      this.carUserType = val.carUserType;
    },

    async setList (salaryPatternOptions) {
      this.baseForm.salaryPatternOptions = salaryPatternOptions;
    },

    salaryPatternChange () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['salary', 'subsidy', 'incomeRatio', 'basicSalary', 'minimumWage'],
      });
      const salaryPattern = this.$refs.baseForm.getVal('salaryPattern');
      if (salaryPattern === '3' || salaryPattern === '4') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['incomeRatio'],
        });
      }
      if (salaryPattern !== '5') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['salary', 'subsidy'],
        });
      }
      // 底薪和保底工资
      if (salaryPattern === '5') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['basicSalary', 'minimumWage'],
        });
      }
    },

    async sub () {
      if (this.userInfo || this.carUserType !== '1') {
        return {};
      } else {
        const formData = await this.$refs.baseForm.sub();
        if (formData) {
          let userSalaryInfoList = this.$refs.setSalary.sub();
          if (userSalaryInfoList) {
            userSalaryInfoList = JSON.stringify(userSalaryInfoList);
          }
          formData.userSalaryInfoList = userSalaryInfoList;
          if (formData.salary) { // 基本工资
            formData.salary = floatMutiply(formData.salary, 100);
          }
          if (formData.subsidy) { // 补贴金额
            formData.subsidy = floatMutiply(formData.subsidy, 100);
          }
          // if (formData.basicSalary) { // 底薪
          //   formData.basicSalary = floatMutiply(formData.basicSalary, 100);
          // }
          // if (formData.minimumWage) { // 保底工资
          //   formData.minimumWage = floatMutiply(formData.minimumWage, 100);
          // }
          formData.entryState = new Date(formData.entryDate) < new Date() ? 1 : 0;
          if (formData.entryDate) {
            formData.entryDate = this.formatDate(formData.entryDate);
          }
        }
        return formData;
      }
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      res.userSalaryInfoList = this.$refs.setSalary.sub();
      if (res.salary) { // 基本工资
        res.salary = res.salary * 100;
      }
      if (res.subsidy) { // 补贴金额
        res.subsidy = res.subsidy * 100;
      }
      if (res.basicSalary) { // 底薪
        res.basicSalary = res.basicSalary * 100;
      }
      if (res.minimumWage) { // 保底工资
        res.minimumWage = res.minimumWage * 100;
      }
      return res;
    },
    init (data = {}) {
      this.salaryPatternNameVer = data.salaryPatternName !== data.salaryPatternNameVer ? data.salaryPatternNameVer : '';

      this.$refs.baseForm.reset();
      if (data.salaryPattern) {
        data.salaryPattern = String(data.salaryPattern);
      } else {
        data.salaryPattern = this.baseForm.salaryPatternOptions[0].value;
      }
      if (data.salary) { // 基本工资
        data.salary = data.salary / 100;
      } else {
        data.salary = '';
      }
      if (data.subsidy) { // 补贴金额
        data.subsidy = data.subsidy / 100;
      } else {
        data.subsidy = '';
      }
      if (data.basicSalary) { // 底薪
        data.basicSalary = data.basicSalary / 100;
      } else {
        data.basicSalary = '0';
      }
      if (data.minimumWage) { // 保底工资
        data.minimumWage = data.minimumWage / 100;
      } else {
        data.minimumWage = '0';
      }
      data.entryDate = data.entryDate ? new Date(data.entryDate) : this.formatDate(new Date());
      this.$refs.baseForm.setVal(data);
      this.$refs.setSalary.init(data);
      this.salaryPatternChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
